'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var EMAIL_REGEX = exports.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
/**
 * Regular expression for matching links (used while pasting text from the clipboard to figure out what kind of
 * element to create).
 * From: http://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
 */
var URL_REGEX = exports.URL_REGEX = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g; // eslint-disable-line
var IP_ADDRESS_REGEX = exports.IP_ADDRESS_REGEX = /(http(s)?:\/\/.)?^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d{2,4})?\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/; // eslint-disable-line
var LOCALHOST_REGEX = exports.LOCALHOST_REGEX = /localhost:3000/g;

var FIELD_TYPES = exports.FIELD_TYPES = {
    text: 'text',
    email: 'email',
    password: 'password',
    date: 'date',
    select: 'select',
    html: 'html',
    url: 'url',
    elementId: 'elementId',
    object: 'object',
    objectId: 'objectId'
};

var FAILURE_TYPES = exports.FAILURE_TYPES = {
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO'
};

var FAILURE_NAMES = exports.FAILURE_NAMES = {
    required: 'required',
    email: 'email',
    date: 'date',
    select: 'select',
    password: 'password',
    maxlength: 'maxlength',
    url: 'url',
    elementId: 'elementId',
    object: 'object',
    objectId: 'objectId'
};

var FIELDS = exports.FIELDS = {
    givenName: {
        name: 'givenName',
        type: FIELD_TYPES.text,
        required: true,
        maxLength: 50
    },
    familyName: {
        name: 'familyName',
        type: FIELD_TYPES.text,
        required: true,
        maxLength: 50
    },
    email: {
        name: 'email',
        type: FIELD_TYPES.email,
        required: true,
        maxLength: 255
    },
    password: {
        name: 'password',
        type: FIELD_TYPES.password,
        required: true,
        maxLength: 255
    },
    code: {
        name: 'code',
        type: FIELD_TYPES.text,
        required: true,
        maxLength: 40,
        minLength: 40
    }
};

FIELDS.loginPassword = _extends({}, FIELDS.password, {
    disableTypeValidation: true
});

// Login page & route
var LOGIN_FIELDS = exports.LOGIN_FIELDS = {
    email: FIELDS.email,
    password: FIELDS.loginPassword
};

// Registration page & route
var REGISTER_FIELDS = exports.REGISTER_FIELDS = {
    givenName: FIELDS.givenName,
    familyName: FIELDS.familyName,
    email: FIELDS.email,
    password: FIELDS.password,
    inviteCode: {
        name: 'inviteCode',
        type: FIELD_TYPES.text
    },
    referrerCode: {
        name: 'referrerCode',
        type: FIELD_TYPES.text
    },
    marketingReferralCode: {
        name: 'marketingReferralCode',
        type: FIELD_TYPES.text
    }
};

// Forgotten password page & reset route
var REQUEST_PASSWORD_RESET_FIELDS = exports.REQUEST_PASSWORD_RESET_FIELDS = {
    email: FIELDS.email
};

// Change password page
var CHANGE_PASSWORD_FIELDS = exports.CHANGE_PASSWORD_FIELDS = {
    password: FIELDS.password
};

// Invitaion page & route
var INVITE_FIELDS = exports.INVITE_FIELDS = {
    email: FIELDS.email
};

// Sharing Popup
var ADD_SHARED_USER_FIELDS = exports.ADD_SHARED_USER_FIELDS = {
    userEmail: _extends({}, FIELDS.email, {
        name: 'userEmail',
        hideBeforeSubmit: true
    })
};

var ELEMENT_FIELDS = {
    id: {
        name: 'id',
        type: FIELD_TYPES.elementId,
        required: true
    },
    elementType: {
        name: 'elementType',
        type: FIELD_TYPES.select,
        validValues: ['CARD', 'LINK', 'IMAGE'],
        required: true
    },
    location: {
        name: 'location',
        type: FIELD_TYPES.object,
        keys: [{
            name: 'parentId',
            type: FIELD_TYPES.elementId
        }, {
            name: 'section',
            type: FIELD_TYPES.select,
            validValues: ['CANVAS', 'INBOX']
        }, {
            name: 'position',
            type: FIELD_TYPES.object
        }]
    },
    content: {
        name: 'content',
        type: FIELD_TYPES.object,
        required: true
    }
};

// Creating element with HTTP route
var ELEMENT_CREATE_FIELDS = exports.ELEMENT_CREATE_FIELDS = {
    elementType: ELEMENT_FIELDS.elementType,
    content: ELEMENT_FIELDS.content
};

var ELEMENT_DUPLICATE_FIELDS = exports.ELEMENT_DUPLICATE_FIELDS = {
    id: _extends({}, ELEMENT_FIELDS.id, {
        required: false
    }),
    location: _extends({}, ELEMENT_FIELDS.location, {
        required: true
    })
};

var ELEMENT_UPDATE_FIELDS = exports.ELEMENT_UPDATE_FIELDS = {
    elementType: ELEMENT_FIELDS.elementType,
    content: ELEMENT_FIELDS.content
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validationConstants.js
// module id = 36
// module chunks = 0